<template>
  <div class="wrapper wrapper_wide section_content">
    <div class="frame_wide">
      <AddressMap :wide="true"/>
      <AccessDetail v-bind="vehicle"/>
    </div>
    <!-- <div class="frame_center">
      <Timetable />
      <Fusion />
      <Consultation />
    </div> -->
  </div>
</template>

<script>
// organisms
import AccessDetail from '../organisms/accessDetail.vue'
import AddressMap from '../organisms/addressMap.vue'
import Fusion from '../organisms/fusion.vue'
import Timetable from '../organisms/timetable.vue'
import Consultation from '../organisms/consultation.vue'

import { mapState } from 'vuex'

export default {
  name: 'AccessContents',
  components: {
    AccessDetail,
    AddressMap,
    Fusion,
    Timetable,
    Consultation
  },
  props: {
    msg: String
  },
  data () {
    return {
      vehicle: siteData.access
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
